import ReactSortable from './ReactSortable';

export default ReactSortable;
